import { hashHistory } from 'react-router';
import { isPluginMode } from './isPluginMode';

let preventRedirect: boolean | null = null;

export const redirectTo = (url, skip = false, clientId = '') => {
  if (isPluginMode()) {
    if (preventRedirect) {
      hashHistory.replace(url + clientId);
    }
    else {
      const location = hashHistory.getCurrentLocation();
      hashHistory.push({
        ...location,
        pathname: url,
        search: clientId
      })
    }
    preventRedirect = skip; 
  } else {
    hashHistory.replace(url);  
  }
}
